export default __webpack_public_path__ + "static/media/TempImg.e73ac9fb.svg";